module.exports = __webpack_public_path__ + "public/media/developer-vector3.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/developer-vector3.png
// module id = ./images/services/developer-vector3.png
// module chunks = 0